<template>
  <div class="quill-editor">
    <slot name="toolbar"></slot>
    <div v-show="!sourceCode" ref="editor"></div>
    <div v-if="sourceCode" name="sourceCode">
      <textarea v-model="content" style="width:100%;height:300px;" @blur="changeContent">
      </textarea>
    </div>
  </div>
</template>

<script>
  // require sources
  import _Quill from 'quill'
  import defaultOptions from './options'
  const Quill = window.Quill || _Quill
  const BlockEmbed = Quill.import('blots/block/embed');

  class Divider extends BlockEmbed { 
    static create (value) {
      let node = super.create(value)
      node.setAttribute('type', 'text');
      node.setAttribute('value', value);
      node.setAttribute('class', 'bxstoeflparrows');
      return node
    }
  }
  Divider.blotName = 'divider'
  Divider.tagName = 'span'
  // 注册
  Quill.register(Divider);

  var Link = Quill.import('formats/link');
  class FileBlot extends Link {  // 继承Link Blot
    static create(value) {
      let node = undefined
      if (value&&!value.href){  // 适应原本的Link Blot
        node = super.create(value);  
      }
      else{  // 自定义Link Blot
        node = super.create(value.href);  
        node.setAttribute('aType', value.aType);  // 左键点击即下载
        node.setAttribute('class', 'bxstoeflparrows');
        node.innerText = value.innerText;
      }
      return node;
    }
  }
  FileBlot.blotName = 'link';
  FileBlot.tagName = 'A';
  Quill.register(FileBlot);

  // pollfill
  if (typeof Object.assign != 'function') {
    Object.defineProperty(Object, 'assign', {
      value(target, varArgs) {
        if (target == null) {
          throw new TypeError('Cannot convert undefined or null to object')
        }
        const to = Object(target)
        for (let index = 1; index < arguments.length; index++) {
          const nextSource = arguments[index]
          if (nextSource != null) {
            for (const nextKey in nextSource) {
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey]
              }
            }
          }
        }
        return to
      },
      writable: true,
      configurable: true
    })
  }

  // export
  export default {
    name: 'quill-editor',
    data() {
      return {
        _options: {},
        content: '',
        defaultOptions,
        sourceCode:false
      }
    },
    props: {
      value: String,
      disabled: {
        type: Boolean,
        default: false
      },
      options: {
        type: Object,
        required: false,
        default: () => ({})
      },
      globalOptions: {
        type: Object,
        required: false,
        default: () => ({})
      }
    },
    mounted() {
      this.initialize()
    },
    beforeDestroy() {
      this.quill = null
      delete this.quill
    },
    methods: {
      // Init Quill instance
      initialize() {
        if (this.$el) {

          // Options
          this._options = Object.assign({}, this.defaultOptions, this.globalOptions, this.options)

          // Instance
          this.quill = new Quill(this.$refs.editor, this._options)
          
          this.quill.enable(false)

          // Set editor 
          if (this.value) {
            this.quill.pasteHTML(this.value)
          }

          // Disabled editor
          if (!this.disabled) {
            this.quill.enable(true)
          }

          // Mark model as touched if editor lost focus
          this.quill.on('selection-change', range => {
            if (!range) {
              this.$emit('blur', this.quill)
            } else {
              this.$emit('focus', this.quill)
            }
          })

          // Update model if text changes
          this.quill.on('text-change', (delta, oldDelta, source) => {
            let html = this.$refs.editor.children[0].innerHTML
            const quill = this.quill
            const text = this.quill.getText()
            if (html === '<p><br></p>') html = ''
            this.content = html
            this.$emit('input', this.content)
            this.$emit('change', { html, text, quill })
          })

          // Emit ready event
          this.$emit('ready', this.quill)
        }
      },
      /**
       * 切换源代码的显示和隐藏
       */
      changeSourceCode(){
        this.sourceCode = !this.sourceCode;
      },
      changeContent(){
        console.log("content=========",this.content);
        if(this.content && this.content == "") {
          this.quill.pasteHTML("<p></p>");
        } else {
          this.quill.pasteHTML(this.content);
        }
      }
    },
    watch: {
      // Watch content change
      /*content(newVal, oldVal) {
        console.log("content进入==");
        
        if (this.quill) {
          if (newVal && newVal !== this.content) {
            this.content = newVal
            this.quill.pasteHTML(newVal)
          } else if(!newVal) {
            this.quill.setText('')
          }
        }
      },*/
      // Watch content change
      value(newVal, oldVal) {
        console.log("value进入==",newVal,oldVal,this.content);
        if (this.quill) {
          if (newVal && newVal !== this.content) {
            this.content = newVal
            this.quill.pasteHTML(newVal)
          } else if(!newVal) {
            this.quill.setText('')
          }
        }
      },
      // Watch disabled change
      disabled(newVal, oldVal) {
        if (this.quill) {
          this.quill.enable(!newVal)
        }
      }
    }
  }
</script>
<style>
  .bxstoefltexthl{background:#d3d3d3;}
  .bxstoeflparrows{border:0px;width:28px;height:15px;background-color:#666;color:#fff;}
  .bxsblacksquarebtn{border:0px;width:16px;height:16px;background-color:#000000;}
  .bxsptextbox{border:1px solid #42598C;text-align:center;}
</style>
